export const isNumber = (value: any) => {
  return !isNaN(value)
}
